import { render, staticRenderFns } from "./CameraTester.vue?vue&type=template&id=653a0cf3&scoped=true&"
import script from "./CameraTester.vue?vue&type=script&lang=js&"
export * from "./CameraTester.vue?vue&type=script&lang=js&"
import style0 from "./CameraTester.vue?vue&type=style&index=0&id=653a0cf3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653a0cf3",
  null
  
)

export default component.exports